/* eslint-disable */
import updateSubscription from "@auer-steel/Handlers/UpdateSubscription";
import mergeToNew from "@insite/client-framework/Common/mergeToNew";
import { HasProductContext, withProductContext } from "@insite/client-framework/Components/ProductContext";
import { makeHandlerChainAwaitable } from "@insite/client-framework/HandlerCreator";
import ApplicationState from "@insite/client-framework/Store/ApplicationState";
import { getSettingsCollection } from "@insite/client-framework/Store/Context/ContextSelectors";
import { hasEnoughInventory } from "@insite/client-framework/Store/Data/Products/ProductsSelectors";
import { canAddToCart } from "@insite/client-framework/Store/Pages/ProductDetails/ProductDetailsSelectors";
import translate from "@insite/client-framework/Translate";
import * as React from "react";
import { connect, ResolveThunks } from "react-redux";
import { css } from "styled-components";
import InjectableCss from "@insite/mobius/utilities/InjectableCss";
import Link from "@insite/mobius/Link";

interface OwnProps {
    labelOverride?: string;
    extendedStyles?: InjectableCss;
    handler: any;
}

type Props = OwnProps &
    ReturnType<typeof mapStateToProps> &
    ResolveThunks<typeof mapDispatchToProps> &
    HasProductContext;

const mapStateToProps = (state: ApplicationState, props: HasProductContext) => {
    return {
        productSettings: getSettingsCollection(state).productSettings,
        canAddToCart: canAddToCart(state, props.productContext.product),
        hasEnoughInventory: hasEnoughInventory(state, props.productContext),
    };
};

const mapDispatchToProps = {
    updateSubscription: makeHandlerChainAwaitable(updateSubscription),
};

export const productAddToCartButtonStyles: InjectableCss = {
    css: css`    
        margin-top: 30px;
        text-align: start;
        justify-content: flex-start;
        font-weight: bold;
    `,
};

const ProductUnsubscribeButton: React.FC<Props> = ({
    productContext: {
        product,
        productInfo: { qtyOrdered, unitOfMeasure, inventory },
    },
    updateSubscription,
    extendedStyles,
    handler,
    ...otherProps
}) => {
    const [styles] = React.useState(() => mergeToNew(productAddToCartButtonStyles, extendedStyles));

    return (
        <Link {...styles} onClick={handler} {...otherProps}>
            {translate("Unsubscribe")}
        </Link>
    );
};
export default withProductContext(connect(mapStateToProps, mapDispatchToProps)(ProductUnsubscribeButton));
